import { useMutation, useQueryClient } from '@tanstack/react-query';

import { CruiseInclusionFilter } from '~/components/Cruises/pages/Inclusions/types';

import inclusionsService from '~/services/cruises/InclusionsService';

import { inclusionQueryKeys } from './inclusionQueryKeys';

interface CreateFiltersParams {
  inclusionId: string;
  filters: Array<Pick<CruiseInclusionFilter, 'filterId' | 'filterType'>>;
}

export function useCreateInclusionFilters() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ inclusionId, filters }: CreateFiltersParams) =>
      inclusionsService.createFiltersBulk(inclusionId, filters),
    onSuccess: (_result, variables) => {
      queryClient.invalidateQueries({ queryKey: inclusionQueryKeys.filters(variables.inclusionId) });
    },
  });
}
